import { render, staticRenderFns } from "./BizProcessModule.vue?vue&type=template&id=0e838af0&scoped=true&"
import script from "./BizProcessModule.vue?vue&type=script&lang=js&"
export * from "./BizProcessModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e838af0",
  null
  
)

export default component.exports